import styled, { css } from 'styled-components';
import React from 'react';
import { Link } from 'react-router-dom';

import { appType } from '@/core/config';
import { APP_DOMAIN } from '@/core/constants/app-domain';

export const base = css`
  background: #fff;
  padding: 24px;
  height: 72px;
  box-sizing: content-box;
  border-radius: 44px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 12px;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;

  text-decoration: none;

  svg {
    width: 72px;
    height: 72px;
  }

  &:hover {
    box-shadow: 0 18px 36px 0 rgba(0, 0, 0, 0.48);
    transform: translateY(-4px);

    svg.animated {
      transition: all 0.3s ease;
      transform: translateX(32px);
    }
  }
`;
const StyledLink = styled(Link)`
  ${base}
`;

const StyledAnchor = styled.a`
  ${base}
`;

type IconsContainerProps = {
  children: React.ReactNode;
  href: string;
};

export const IconsContainer: React.FC<IconsContainerProps> = ({ children, href }) => {
  if (appType !== 'app') {
    return <StyledAnchor href={`${APP_DOMAIN}${href}`}>{children}</StyledAnchor>;
  }

  return <StyledLink to={href}>{children}</StyledLink>;
};
